define('entities/lis',[
  'app',
  'backbone',
  'settings',
  'jquery',
  'underscore'
], function(
  App,
  Backbone,
  Settings,
  $,
  _
) {
  'use strict';

  var Lis = Backbone.Model.extend({
    fetch: function() {
      this.url = Settings.url('compuzz', 'v2/lis/' + this.get('secId'));

      return Backbone.Model.prototype.fetch.call(this);
    },
    defaults: {
      code: '',
      name: '',
      smpidTrt: 'NO'
    },
    idAttribute: 'secId',
    getImageUid:function() {},

    postUrl: function () {
      return Settings.url('compuzz', 'v2/lis');
    },

    save: function() {
      this.url = this.postUrl();
      return Backbone.Model.prototype.save.call(this);
    }
  });

  var LisCollection = Backbone.Collection.extend({
    url: function() {
      return Settings.url('compuzz', 'v2/lis');
    },
    model: Lis
  });

  var API = {

    getLisCollectionUrl: function() {
      new LisCollection();
      var params = {};
      return Settings.url('compuzz', 'v2/lis', params);
    },

    getAllLis: function(params) {
      var url = Settings.url('compuzz', 'v2/lis', params),
          defer = $.Deferred();

      $.ajax({
        method: 'get',
        url: url,
        success: function(items) {
          var list = [];
          _.each(items, function(item){
            list.push(item.secId);
          });
          defer.resolve(list);
        }
      });

      return defer.promise();
    },

    getLisCountUrl: function() {
      var params = '';
      return 'v2/lis/rowCount' + params;
    },

    deleteLis: function(secId){
      var url = Settings.url('compuzz', 'v2/lis/'+secId),
          defer = $.Deferred();

      $.ajax({
        type: 'DELETE',
        url: url,
        success: function (data) {
          defer.resolve(data);
        }
      });

      return defer.promise();
    }
  };

  App.reqres.setHandler('lis:get-collection-url', function() {
      return API.getLisCollectionUrl();
  });

  App.reqres.setHandler('lis:get-collection-to-page', function(params) {
      return API.getAllLis(params);
  });

  App.reqres.setHandler('lis:get-count-url', function() {
    return API.getLisCountUrl();
  });

  App.reqres.setHandler('lis:model', function(itemJSON) {
    return new Lis(itemJSON);
  });

  App.reqres.setHandler('lis:delete', function(secId) {
    return API.deleteLis(secId);
  });
});
